module.exports = __webpack_public_path__ + "img/agents-black.650a3f74.svg";